module.exports = __webpack_public_path__ + "img/item1.c86f0760.jpg";